export const MICROFORM_URL = 'https://flex.cybersource.com/cybersource/assets/microform/0.11/flex-microform.min.js';
